// (c) chaehongee. Confidential and proprietary.

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../store/hooks/useAuth'
import styles from './AuthCallback.module.css'

export function AuthCallback() {
    const { user, loading } = useAuth()
    const { t } = useTranslation('auth')
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (loading) return

        if (user) {
            // User successfully authenticated
            const returnUrl = sessionStorage.getItem('auth_return_url')
            sessionStorage.removeItem('auth_return_url')

            // Navigate to returnUrl or home
            const targetUrl = returnUrl || '/'
            window.location.href = targetUrl
        } else {
            // Check for OAuth error in URL
            const params = new URLSearchParams(window.location.search)
            const errorParam = params.get('error')
            const errorDescription = params.get('error_description')

            if (errorParam) {
                setError(errorDescription || errorParam)
            } else {
                setError(t('authFailed'))
            }
        }
    }, [user, loading, t])

    if (loading) {
        return (
            <div className={styles.container} style={{ cursor: 'wait' }}>
            </div>
        )
    }

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.errorCard}>
                    <h2>{t('signInFailed')}</h2>
                    <p>{error}</p>
                    <button
                        onClick={() => {
                            window.location.href = '/login'
                        }}
                        className={styles.retryButton}
                    >
                        {t('tryAgain')}
                    </button>
                </div>
            </div>
        )
    }

    // User authenticated - redirect immediately without showing loading state
    return (
        <div className={styles.container} style={{ cursor: 'wait' }}>
        </div>
    )
}

